<template>
  <div
    class="modal fade driverModal"
    id="driverModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="driverModalLabel"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div>
            <h3>司機呼號：</h3>
            <span>{{ driverNumber }}</span>
          </div>
          <div>
            <h3>目前餘額：</h3>
            <span>${{ record.amount }}</span>
          </div>
          <div>
            <div class="amount-box">
              <h3>輸入金額：</h3>
              <div class="input-group">
                <input
                  type="number"
                  class="form-control"
                  v-model="amount"
                  min="1"
                  max="1000"
                />
              </div>
              <div style="margin: 0 15px">
                <input
                  type="radio"
                  id="stored"
                  name="radio-group"
                  value="1"
                  v-model="type"
                  checked
                />
                <label for="stored">儲值</label>
              </div>
              <div>
                <input
                  type="radio"
                  id="refund"
                  name="radio-group"
                  value="0"
                  v-model="type"
                />
                <label for="refund">退款</label>
              </div>
            </div>
            <a class="btn btn-danger" href="#" @click.prevent="cancel">取消</a>
            <a class="btn btn-primary" href="#" @click.prevent="send">
              確認送出
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/assets/js/libs/API'

export default {
  props: ['driverNumber', 'record'],
  data() {
    return {
      amount: 0,
      type: 1,
    }
  },
  methods: {
    send() {
      if (this.amount < 0) {
        alert('輸入的金額不能夠為負數')
        return
      } else if (this.amount > 5000) {
        alert('單次儲值金額不得超過 5000')
        return
      } else if (this.amount === 0) {
        alert('輸入金額必須大於 0')
        return
      }
      const data = {
        amount: Number(this.amount),
        type: Number(this.type),
      }
      console.log(data)
      API.post(`store_value/${this.driverNumber}`, data)
        .then((res) => {
          this.amount = 0
          if (this.type === 1) {
            this.swal('success', '成功儲值')
          } else {
            this.swal('success', '退款成功')
          }
          this.type = 1
          $('#driverModal').modal('hide')
        })
        .catch((error) => {
          console.log(error.data)
        })
    },
    cancel() {
      this.amount = 0
      this.type = 1
      $('#driverModal').modal('hide')
    },
    swal(status, title) {
      this.$swal.fire({
        title: `${title}`,
        icon: `${status}`,
        footer: '<a href="#/serviceMain/stored-record">查看儲值紀錄<a>',
        confirmButtonColor: '#337ab7',
      })
    },
  },
}
</script>

<style scoped lang="scss">
.driverModal {
  h3 {
    display: inline-block;
    font-size: 21px;
    margin: 15px 0;
    font-weight: bold;
  }
  span {
    color: black;
    font-size: 21px;
  }
  a {
    margin-top: 20px;
    margin-left: 0px;
    display: inline-block;
    width: 90px;
  }
  .form-control {
    margin: 5px 0;
  }
  .input-group {
    margin-bottom: 0px;
    input {
      border-radius: 5px;
    }
    input:focus {
      border-color: #337ab7;
    }
  }
  .amount-box {
    display: flex;
    align-items: center;
    label {
      margin-bottom: 0;
    }
  }
}
[type='radio']:checked,
[type='radio']:not(:checked) {
  position: absolute;
  left: -9999px;
}
[type='radio']:checked + label,
[type='radio']:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #666;
}
[type='radio']:checked + label:before,
[type='radio']:not(:checked) + label:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 1px solid #ddd;
  border-radius: 100%;
  background: #fff;
}
[type='radio']:checked + label:after,
[type='radio']:not(:checked) + label:after {
  content: '';
  width: 12px;
  height: 12px;
  background: #337ab7;
  position: absolute;
  top: 3px;
  left: 3px;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
[type='radio']:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
}
[type='radio']:checked + label:after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}
</style>



// WEBPACK FOOTER //
// src/components/stored/StoredModal.vue